import styled, { css } from "styled-components";

// type CardProps = {
//   bgcolor?;
// }

export const Card = styled.div`
  ${({ theme, bgcolor }) => {
    const { colors, sizes } = theme;
    return css`
      border-radius: ${sizes.radius.lg};
      padding: ${theme.sizes.spacing.md};
      background-color: ${bgcolor || colors.card};
    `;
  }}
  width: 100%;
  min-height: 10px;
`;
